import ExpandLeft from '../../../assets/icons/ExpandLeft';
import * as React from 'react';
import PaymentHistoryTable from '../payment/PaymentHistoryTable';
import { useParams } from 'react-router-dom';
import { Button, GroupButton, SidebarDrawer, Tab } from '../../common';
import { getInvoiceStatus, formatMoney, history } from '../../../utils';
import { toast } from 'react-hot-toast';
import { copyToClipboard } from '../../../utils';
import { DownloadIcon, PrintIcon } from '../../../assets/icons';
import { InvoiceDocument } from '../InvoiceDocument';
import { useDownloadInvoice } from '../../../hooks';
import { IInvoice } from '../../../@types';
import { usePrinter } from '../../../hooks';
import { Statuses } from '../../../constants';
import { useState, useEffect } from 'react';
import { CancelConfirmationPrompt } from '../CancelConfirmation';
import { getPaymentReminder } from '../../../backend-services';
import { useUserStore } from '../../../state/useUserStore';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import { SendReminderPrompt } from '../SendReminderPrompt';
import LeftNotificationPopup from '../../core/NotificationPopup/LeftNotificationPopup';
import { useLocation } from 'react-router-dom';
import { clearFieldError } from '../../../utils/handleErrors';
import { invoiceToReceiptData, ReceiptData } from '../../../utils/EscPosEncoder';
import { RefundConfirmationPrompt } from '../RefundConfirmationPrompt';
import { ManualRecordPayment } from '../../payments/RecordPayment/Manual';
import { UploadTransactionEvidence } from '../../payments/RecordPayment/Upload';

interface ViewInvoiceProps {
  invoice: IInvoice | undefined;
  handleReOccurringInvoice: any;
  handleCancelInvoice: any;
  handleRefundInvoice: any;
  isRefunding: boolean;
  customerId: string;
}
const ViewInvoice: React.FC<ViewInvoiceProps> = ({
  invoice,
  handleReOccurringInvoice,
  handleCancelInvoice,
  handleRefundInvoice,
  isRefunding,
  customerId,
}) => {
  const params = useParams();
  const invoiceId = params.invoiceNo;
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const showPaymentParams = Object.fromEntries(urlParams.entries());
  const [fetchedInvoice, setFetchedInvoice] = useState<IInvoice | null>(null);
  const [showRecordPayment, setShowRecordPayment] = React.useState(false);
  const [isReoccurringEndDate, setIsReoccurringEndDate] = React.useState<string>(invoice?.isReoccurringEndDate ?? '');
  const [isReoccurring, setIsReoccurring] = React.useState<boolean>(invoice?.isReoccurring || false);
  const [showPrompt, setShowPrompt] = React.useState(false);
  const [showRefundPrompt, setShowRefundPrompt] = React.useState(false);
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState<IInvoice | null>(null);
  const [, setSelectedValue] = React.useState('');
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [reoccurringGroupName, setReoccurringGroupName] = React.useState(invoice?.reoccurringGroupName ?? '');
  const [areDatesValid, setAreDatesValid] = React.useState<boolean>(true);
  const [, setLoading] = React.useState(false);
  const [reloadSignal, setReloadSignal] = useState(0);
  const { requestDevice } = usePrinter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [, setPaymentReminder] = useState(null);
  const [isReminderSent, setIsReminderSent] = React.useState(false);
  const [, setIsCancelled] = React.useState(false);
  const [nextReoccurringDate, setNextReoccuringDate] = React.useState<string>('');
  const [triggerAction, setTriggerAction] = useState<boolean>(true);
  const [, setShowIsReoccurringEndDateError] = useState(false);
  const [, setShowReoccurringGroupNameError] = useState(false);
  const [receipt, setReceipt] = useState<ReceiptData>();

  const copyPaymentLink = async () => {
    await copyToClipboard('https://example.com/payment-link');
    toast.success('Payment Link copied');
  };

  const { user, fetchUserProfile, fetchBankData } = useUserStore();

  React.useEffect(() => {
    const fetchUserProfileData = async () => {
      await fetchUserProfile();
    };

    fetchUserProfileData();
  }, [fetchUserProfile]);

  React.useEffect(() => {
    if (user && invoice) {
      const receipt = invoiceToReceiptData(invoice, user?.businessName);
      setReceipt(receipt);
      const userAddress = user.address || '';

      if (!user.bankData) {
        fetchBankData().then(() => {});
      } else {
      }
    }
  }, [user, fetchBankData]);

  const handleNewPayment = () => {
    setReloadSignal((prevSignal) => prevSignal + 1);
    setShowRecordPayment(false);
  };

  useEffect(() => {
    return () => {
      setTriggerAction(false);
    };
  }, []);

  const handleNewUploadPayment = async (isUploadedPayment: boolean) => {
    if (isUploadedPayment && params && params.invoiceNo) {
      setLoading(true);
      setReloadSignal((prevSignal) => prevSignal + 1);
      // setTriggerAction(true);
      // console.log(reloadSignal);
      setShowRecordPayment(false);
    }
  };

  const handleReoccurringEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = event.target.value;
    setIsReoccurringEndDate(inputDate);
    clearFieldError('isReoccurringEndDate', validationResults, setValidationResults);
  };

  React.useEffect(() => {}, [areDatesValid]);

  const isInvoiceCancelled = invoice?.status === Statuses.CANCELLED.toLowerCase();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const PaymentReminder = async () => {
    try {
      if (invoiceId) {
        const reminder = await getPaymentReminder(invoiceId);
        setPaymentReminder(reminder);
        setIsReminderSent(true);
      }
    } catch (error) {
      toast.error('Failed to send payment reminder.');
    }
  };

  const handleCancelInvoiceWithSuccessModal = async () => {
    try {
      await handleCancelInvoice();
      setIsCancelled(true);
    } catch (error) {
      toast.error('Failed to cancel the invoice');
    }
  };

  const handleChange = (name: string, selectedValue: string) => {
    setReoccurringGroupName(selectedValue);
    clearFieldError('reoccurringGroupName', validationResults, setValidationResults);
  };

  function getNextInvoiceDate(issueDate: string, frequency: any) {
    let invoiceDate: any = new Date(issueDate);
    let today: any = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    const daysElapsed = Math.floor((today - invoiceDate) / oneDay);

    switch (frequency) {
      case 'weekly':
        let weeksSinceIssue = Math.floor(daysElapsed / 7);
        invoiceDate.setDate(invoiceDate.getDate() + (weeksSinceIssue + 1) * 7);
        break;
      case 'yearly':
        let yearsSinceIssue = Math.floor(daysElapsed / 365);
        invoiceDate.setFullYear(invoiceDate.getFullYear() + yearsSinceIssue + 1);
        break;
      case 'monthly':
        while (invoiceDate <= today) {
          invoiceDate.setMonth(invoiceDate.getMonth() + 1);
        }
        break;
    }
    return invoiceDate;
  }

  React.useEffect(() => {
    if (invoice?.issueDate && invoice?.reoccurringGroupName) {
      const nextInvoiceDate = getNextInvoiceDate(invoice?.issueDate, invoice?.reoccurringGroupName);
      const formattedNextInvoiceDate = nextInvoiceDate?.toLocaleDateString('en-NG');
      setNextReoccuringDate(`Next invoice date for ${invoice?.reoccurringGroupName}: ${formattedNextInvoiceDate}`);
    }
  }, [invoice?.issueDate, invoice?.reoccurringGroupName]);

  React.useEffect(() => {
    if (showPaymentParams.action === 'showPayment') {
      setShowRecordPayment(true);
    }
  }, [showPaymentParams.action]);

  const [validationResults, setValidationResults] = React.useState({
    reoccurringGroupName: '',
    isReoccurringEndDate: '',
  });

  const [showUploadModal, setShowUploadModal] = useState(false);

  const openUploadModal = () => {
    setShowRecordPayment(true);
  };

  const closeUploadModal = () => {
    setShowRecordPayment(false);
  };

  const handleReoccurringChange = () => {
    if (!isReoccurring) {
      if (!isReoccurringEndDate) {
        setShowIsReoccurringEndDateError(true);
        setValidationResults((prevState) => ({
          ...prevState,
          isReoccurringEndDate: 'Please select an end date',
        }));
        setIsReoccurring(false);
      } else if (!reoccurringGroupName) {
        setShowReoccurringGroupNameError(true);
        setValidationResults((prevState) => ({
          ...prevState,
          reoccurringGroupName: 'Please select a recurrence interval',
        }));
        setIsReoccurring(false);
      } else {
        setIsReoccurring(true);
        handleReOccurringInvoice({
          id: invoice?.id,
          isReoccurringEndDate: isReoccurringEndDate,
          reoccurringGroupName,
        });
      }
    } else {
      setShowIsReoccurringEndDateError(false);
      setShowReoccurringGroupNameError(false);
      setValidationResults((prevState) => ({
        ...prevState,
        isReoccurringEndDate: '',
        reoccurringGroupName: '',
      }));
      setIsReoccurring(false);
    }
  };

  const handleUpdate = (updatedInvoice: IInvoice) => {
    setSelectedInvoice(updatedInvoice);
  };
  const { downloadPDF, isLoading } = useDownloadInvoice({
    //@ts-ignore
    invoice: invoice,
    //@ts-ignore
    invoiceId: invoiceId,
    onUpdate: handleUpdate,
  });

  const handleDownloadPDF = async () => {
    try {
      await downloadPDF();
      console.log('Download completed successfully');
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  return invoice ? (
    <>
      {/* Desktop screens */}
      <div className="hidden md:flex items-center gap-[22px]">
        <a href="/invoices">
          <h1 className="font-bold text-[20px] flex items-center">
            <div className="mt-[5px] ">
              <ExpandLeft />
            </div>
            {invoice.invoiceNumber}
          </h1>
        </a>
        {getInvoiceStatus(invoice.status)}
      </div>

      {/*  mobile screens */}
      <div className="flex w-[115%] md:hidden justify-between items-center mx-[-20px]">
        <a href="#goback" onClick={history.back}>
          <div className="mt-[5px]">
            <ExpandLeft />
          </div>
        </a>
        <div>
          <p className="text-[#044E97] text-[14px]">{invoice.invoiceNumber}</p>
        </div>

        <div>
          {invoice.status !== Statuses.PAID.toLowerCase() && invoice.status !== Statuses.DUE.toLowerCase() && (
            <button
              onClick={() => setShowPrompt(true)}
              className="text-[12px]"
              style={{
                color:
                  invoice.status === Statuses.CANCELLED.toLowerCase() ||
                  invoice.status === Statuses.REFUNDED.toLowerCase()
                    ? '#ccc'
                    : '#E02523',
              }}
            >
              Cancel
            </button>
          )}

          {invoice.status === Statuses.PAID.toLowerCase() && !isRefunding && (
            <button onClick={() => setShowRefundPrompt(true)} className="text-[12px]" style={{ color: '#E02523' }}>
              Refund
            </button>
          )}
        </div>
      </div>

      {/*  mobile screen */}
      <div className="flex md:hidden flex-col justify-center mx-[-10%] xs:mx-5">
        <div className="flex flex-col sm:w-[200%] lg:w-full">
          <div className="flex lg:hidden items-center justify-between gap-[10px] flex-row ">
            {getInvoiceStatus(invoice.status)}
            <p className="font-sm  mb-[30px] pt-[24px] text-[14px] ">
              Created:{' '}
              <span className="text-[#6A32C6] text-[14px]">
                {new Date(invoice.createdAt).toLocaleDateString('en-NG', {
                  month: 'numeric',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </span>
            </p>
          </div>
          <div className="flex flex-row justify-between py-[12px]">
            {Number(invoice.balanceDue) !== 0 ? (
              <p className="font-light text-[#000000] not-italic  text-[12px] leading-6 tracking-wide sm:text-[70%] md:text-[12px] mb-[] ">
                You're due{' '}
                <span className="font-semibold text-[14px] mb-[30px]">
                  {formatMoney(invoice.balanceDue, invoice.currency)}
                </span>{' '}
              </p>
            ) : (
              <p>
                <p className="font-light text-[#000000] not-italic  text-[14px] leading-6 tracking-wide sm:text-[14px] md:text-[14px] mb-[] ">
                  You're due <span className="font-semibold text-[14px] mb-[30px]">{formatMoney(0)}</span>{' '}
                </p>
              </p>
            )}

            <p className="text-[14px] ml-[-1.9em]">
              Exchange rate: <span className="text-[14px]">{formatMoney(invoice.exchangeRate)}</span>
              <span className="text-xs"> per {invoice.currency}</span>
            </p>
          </div>
          <div>
            <div className="mt-[34px]">
              <InvoiceDocument invoice={invoice} address={user.address} bankData={user.bankData} />
            </div>
            <div className="mt-[1em]">
              <hr className="mt-[5px]" />
            </div>
          </div>

          <div className="z-50 mx-auto max-w-[1012px] py-[20px] bottom-[0] mt-[-1em]  w-full px-[32px] ">
            <div className="flex flex-col items-center justify-center">
              <div className="mb-[13px] items-center flex justify-center w-[180px]">
                <Button
                  text="Record Payment"
                  variant="secondary"
                  size="small"
                  onClick={() => setShowRecordPayment(true)}
                  disabled={invoice.status === Statuses.CANCELLED.toLowerCase()}
                />
              </div>

              <div className="text-[19px] ">
                <GroupButton
                  buttons={[
                    {
                      text: 'Download',
                      icon: <DownloadIcon />,
                      onClick: handleDownloadPDF,
                      disabled: isLoading,
                    },
                    // {
                    //   text: 'Print',
                    //   icon: <PrintIcon />,
                    //   onClick: requestDevice,

                    // },
                    // {
                    //   text: 'Send Reminder',
                    //   icon: <PrintIcon />,
                    //   onClick: () => setIsSidebarOpen(true),
                    // },
                  ]}
                />
              </div>
            </div>
          </div>
          {isSidebarOpen && (
            <SidebarDrawer 
            title={'Send Reminder'} 
            show={true} 
            position={'left'}
            onClose={() => setIsSidebarOpen(false)}
            >
              <SendReminderPrompt
                onSend={PaymentReminder}
                onClose={() => setIsSidebarOpen(false)}
                isSidebarOpen={isSidebarOpen}
                invoice={invoice}
                //ts-ignore
                customerId={customerId}
              />
            </SidebarDrawer>
          )}
          {isReminderSent && (
            <SidebarDrawer title={''} show={true} position={'left'}>
              <LeftNotificationPopup title={'You sent a payment reminder'} icon={<ProcessSuccessful />} />
            </SidebarDrawer>
          )}
          {showPrompt && (
            <>
              <SidebarDrawer title="Cancel Invoice" show={true} onClose={() => setShowPrompt(false)} position={'left'}>
                <CancelConfirmationPrompt
                  onCancel={handleCancelInvoiceWithSuccessModal}
                  onClose={() => setShowPrompt(false)}
                  showPrompt={showPrompt}
                />
              </SidebarDrawer>
              )
            </>
          )}
          {invoice.status === Statuses.PAID.toLowerCase() && (
            <>
              {showRefundPrompt && (
                <SidebarDrawer
                  title="Refund Invoice"
                  show={true}
                  onClose={() => setShowRefundPrompt(false)}
                  position={'left'}
                >
                  <RefundConfirmationPrompt
                    onRefund={handleRefundInvoice}
                    onClose={() => setShowRefundPrompt(false)}
                    showRefundPrompt={showRefundPrompt}
                  />
                </SidebarDrawer>
              )}
            </>
          )}
          <div className="flex justify-center  justify-stretch">
            <div className="my-[0em] text-[11px] 540:w-[750px] 540:ml-[8em]">
              <PaymentHistoryTable reloadSignal={reloadSignal} />
            </div>
          </div>
        </div>
      </div>
      {/* End of mobile screens */}

      {/* Desktop screens */}
      <div className="hidden md:flex justify-center">
        <div>
          <div className="max-w-full flex justify-between mt-[64px] ml-[30px] lg:ml-0">
            <div className="lg:ml-0 xl:ml-0 biglg:ml-0 ">
              <p className="font-sm text-[18px] mb-[30px] ">
                Created:{' '}
                <span className="font-sm text-[18px] mb-[30px] text-[#6A32C6]">
                  {new Date(invoice.createdAt).toLocaleDateString('en-NG', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </span>
              </p>
              {Number(invoice.balanceDue) !== 0 && (
                <p className="font-normal text-[20px] mb-[30px] ">
                  You're due{' '}
                  <span className="font-semibold text-[25px] mb-[30px]">
                    {formatMoney(invoice.balanceDue, invoice.currency)}
                  </span>{' '}
                </p>
              )}

              <p className=" mt-[1em] text-[18px]">
                Exchange rate: <span>{formatMoney(invoice.exchangeRate)}</span>
                <span className="" style={{ whiteSpace: 'nowrap' }}>
                  {' '}
                  per {invoice.currency}
                </span>
              </p>
            </div>
          </div>
          <div className="mt-[34px] flex justify-center items-center lg:px-0 xl:px-0 biglg:px-0 ">
            <InvoiceDocument invoice={invoice} address={user.address} bankData={user.bankData} />
          </div>
          <div className="flex">
            <hr className="" />
            <div className=" lg:mt-[25em] ">
              <div className="my-0  lg:w-[700px] biglg:w-[850px] xl:w-[946px] 2xl:w-[1024px] biglg:ml-[0.8em] xl:ml-[0.3em]">
                <PaymentHistoryTable reloadSignal={reloadSignal} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="z-50 mx-auto max-w-[1190px] py-[20px] sticky bottom-[0] mt-[32px] bg-[#F2F9FD] w-full border border-[#D6DADD] px-[32px] hidden md:block">
        {' '}
        <div className="flex text-center justify-between ">
          <div className="w-[215px] h-[48px]">
            <Button
              text="Record Purchase"
              variant="secondary"
              size="full"
              onClick={() => setShowRecordPayment(true)}
              disabled={
                invoice.status === Statuses.CANCELLED.toLowerCase() || invoice.status === Statuses.PAID.toLowerCase()
              }
            />
          </div>
          <div className="md:w-[350px] bigmd:w-[480px] md:text-[12px]  lg:w-[250px] biglg:w-[250px] xl:w-[400px] 2xl:w-[350px] text-[16px] h-[41px]">
            <GroupButton
              buttons={[
                {
                  text: 'Download',
                  icon: <DownloadIcon />,
                  onClick: handleDownloadPDF,
                  disabled: isLoading,
                },
                // {
                //   text: 'Send Reminder',
                //   icon: <PrintIcon />,
                //   onClick: () => setIsSidebarOpen(true),
                // },
              ]}
            />
          </div>
          {isSidebarOpen && (
            <SidebarDrawer title={'Send Reminder'} show={true} position={'left'}>
              <SendReminderPrompt
                onSend={PaymentReminder}
                onClose={() => setIsSidebarOpen(false)}
                isSidebarOpen={isSidebarOpen}
                invoice={invoice}
                //ts-ignore
                customerId={customerId}
              />
            </SidebarDrawer>
          )}
          {isReminderSent && (
            <SidebarDrawer title={''} show={true} position={'left'}>
              <LeftNotificationPopup title={'You sent a payment reminder'} icon={<ProcessSuccessful />} />
            </SidebarDrawer>
          )}
          {invoice.status !== Statuses.PAID.toLowerCase() && invoice.status !== Statuses.DUE.toLowerCase() && (
            <div className="lg:w-[215px] md:w-[150px]">
              <Button
                onClick={() => setShowPrompt(true)}
                text="Cancel"
                outline
                size="full"
                variant="danger"
                disabled={
                  invoice.status === Statuses.CANCELLED.toLowerCase() ||
                  invoice.status === Statuses.REFUNDED.toLowerCase()
                }
              />
              {showPrompt && (
                <SidebarDrawer
                  title="Cancel Invoice"
                  show={true}
                  onClose={() => setShowPrompt(false)}
                  position={'left'}
                >
                  <CancelConfirmationPrompt
                    onCancel={handleCancelInvoiceWithSuccessModal}
                    onClose={() => setShowPrompt(false)}
                    showPrompt={showPrompt}
                  />
                </SidebarDrawer>
              )}
            </div>
          )}

          {invoice.status === Statuses.PAID.toLowerCase() && (
            <div className="w-[215px]">
              <Button
                onClick={() => setShowRefundPrompt(true)}
                disabled={isRefunding || invoice.status !== Statuses.PAID.toLowerCase()}
                outline
                size="full"
                variant="danger"
                text="Refund"
              />
              {showRefundPrompt && (
                <SidebarDrawer
                  title="Refund Invoice"
                  show={true}
                  onClose={() => setShowRefundPrompt(false)}
                  position={'left'}
                >
                  <RefundConfirmationPrompt
                    onRefund={handleRefundInvoice}
                    onClose={() => setShowRefundPrompt(false)}
                    showRefundPrompt={showRefundPrompt}
                  />
                </SidebarDrawer>
              )}
            </div>
          )}
        </div>
      </div>

      <SidebarDrawer
        show={showRecordPayment}
        onClose={() => setShowRecordPayment(false)}
        title="Record Payment"
        position={'left'}
      >
        <div className="">
          <Tab
            items={[
              {
                title: 'Upload Receipt',
                component: (
                  <UploadTransactionEvidence
                    entity={invoice}
                    onRecordEntity={handleNewUploadPayment}
                    paymentType="revenue"
                    closeModal={closeUploadModal}
                  />
                ),
              },
              {
                title: 'Record Manually',
                component: <ManualRecordPayment onRecordEntity={handleNewPayment} entity={invoice} />,
              },
            ]}
          />
        </div>
      </SidebarDrawer>
    </>
  ) : null;
};

export { ViewInvoice };
